<template>
  <v-container fluid>
    <v-row class="mb-4" v-if="false">
      <v-col
        class="box-white text-center py-1 text-subtitle-2 text-sm-subtitle-1 text-md-subtitle-1 text-lg-subtitle-1 text-xl-subtitle-1"
      >
        <span> </span>
      </v-col>
    </v-row>
    <v-container v-if="!isQRActive">
      <v-row justify="center" class="my-0 py-0">
        <v-col cols="12" xl="6" lg="7" md="7" sm="8">
          <v-form ref="sampletForm">
            <v-autocomplete
              outlined
              clearable
              dense
              :rules="validation(translations.field_required)"
              :label="translations.label_sample_type"
              background-color="white"
              v-model="sampleTypeSelected"
              :items="items"
              item-text="name"
              @change="sampleTypeChange"
            ></v-autocomplete>
          </v-form>
        </v-col>
      </v-row>
      <v-container v-if="sampleTypeSelected === 'COMPOST'">
        <v-form ref="compostForm">
          <v-row justify="center" class="mb-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="pb-0">
              <v-text-field
                outlined
                clearable
                dense
                :label="translations.label_name"
                :rules="validation(translations.field_required)"
                background-color="white"
                v-model="compostForm.name"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-switch
                v-model="compostForm.isCrop"
                :label="
                  compostForm.isCrop
                    ? translations.label_with_crop
                    : translations.label_without_crop
                "
              ></v-switch>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                v-if="compostForm.isCrop"
                :rules="validation(translations.field_required)"
                :label="translations.label_select_crop"
                background-color="white"
                v-model="compostForm.crop"
                :items="crop_items"
                item-text="text"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_analysis_type"
                background-color="white"
                v-model="compostForm.type"
                :items="analysisType"
                item-text="name"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_compost_type"
                background-color="white"
                v-model="compostForm.composition"
                :items="composition"
                item-text="name"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-textarea
                outlined
                clearable
                :rules="validation(translations.field_required)"
                :label="translations.label_description"
                background-color="white"
                v-model="compostForm.description"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container v-if="sampleTypeSelected === 'PRODUCT'">
        <v-form ref="productForm">
          <v-row justify="center" class="mb-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="pb-0">
              <v-text-field
                outlined
                clearable
                dense
                :label="translations.label_name"
                :rules="validation(translations.field_required)"
                background-color="white"
                v-model="productForm.name"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-switch
                v-model="productForm.isCrop"
                :label="
                  productForm.isCrop
                    ? translations.label_with_crop
                    : translations.label_without_crop
                "
              ></v-switch>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                v-if="productForm.isCrop"
                :rules="validation(translations.field_required)"
                :label="translations.label_select_crop"
                background-color="white"
                v-model="productForm.crop"
                :items="crop_items"
                item-text="text"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_analysis_type"
                background-color="white"
                v-model="productForm.type"
                :items="analysisType"
                item-text="name"
                @change="sampleTypeChange"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_compost_type"
                background-color="white"
                v-model="productForm.composition"
                :items="composition"
                item-text="name"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-text-field
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_product_name_brand"
                background-color="white"
                v-model="productForm.brand"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-text-field
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_active_ingredient"
                background-color="white"
                v-model="productForm.activeIngredient"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-text-field
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_use"
                background-color="white"
                v-model="productForm.useFor"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container v-if="sampleTypeSelected === 'SUBSTRATUM'">
        <v-form ref="substratumForm">
          <v-row justify="center" class="mb-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="pb-0">
              <v-text-field
                outlined
                clearable
                dense
                :label="translations.label_name"
                :rules="validation(translations.field_required)"
                background-color="white"
                v-model="substratumForm.name"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-switch
                v-model="substratumForm.isCrop"
                :label="
                  substratumForm.isCrop
                    ? translations.label_with_crop
                    : translations.label_without_crop
                "
              ></v-switch>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                v-if="substratumForm.isCrop"
                :rules="validation(translations.field_required)"
                :label="translations.label_select_crop"
                background-color="white"
                v-model="substratumForm.crop"
                :items="crop_items"
                item-text="text"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_analysis_type"
                background-color="white"
                v-model="substratumForm.type"
                :items="analysisType"
                item-text="name"
                @change="sampleTypeChange"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-text-field
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_product_name_brand"
                background-color="white"
                v-model="substratumForm.brand"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-textarea
                outlined
                clearable
                :rules="validation(translations.field_required)"
                :label="translations.label_description"
                background-color="white"
                v-model="substratumForm.description"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container v-if="sampleTypeSelected === 'VEGETABLE'">
        <v-form ref="vegetalForm">
          <v-row justify="center" class="mb-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="pb-0">
              <v-text-field
                outlined
                clearable
                dense
                :label="translations.label_name"
                :rules="validation(translations.field_required)"
                background-color="white"
                v-model="vegetalForm.name"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_analysis_type"
                background-color="white"
                v-model="vegetalForm.type"
                :items="analysisType"
                item-text="name"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_plant_sample_type"
                background-color="white"
                :items="vegetalSampleTypes"
                item-text="name"
                v-model="vegetalForm.vegetalType"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_select_crop"
                background-color="white"
                v-model="vegetalForm.crop"
                :items="crop_items"
                item-text="text"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-textarea
                outlined
                clearable
                :rules="validation(translations.field_required)"
                :label="translations.label_description"
                background-color="white"
                v-model="vegetalForm.description"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container v-if="sampleTypeSelected === 'SOLENA_NO_ADVISOR'">
        <v-form ref="samplesNotAdvisorForm">
          <v-row justify="center">
            <v-col cols="12" md="4">
              <v-btn color="primary" dark small block @click="cleanList">{{
                translations.label_clear_list
              }}</v-btn>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn color="primary" dark small block @click="addItem">{{
                translations.label_add_sample
              }}</v-btn>
            </v-col>
          </v-row>
          <v-row justify="center" v-if="isEmptyList.error">
            <span class="red--text text-caption">{{
              isEmptyList.message
            }}</span>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              v-for="(item, index) of samplesNotAdvisorForm.samples"
              :key="index"
            >
              <v-row align="center">
                <v-col>
                  <p class="font-weight-bold">
                    {{ translations.label_sample }} {{ index + 1 }}
                  </p>
                </v-col>
                <v-col class="d-flex justify-end">
                  <v-btn small color="accent" dark @click="deleteItem(index)">{{
                    translations.delete
                  }}</v-btn>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    clearable
                    dense
                    background-color="white"
                    :label="translations.label_name"
                    :rules="validation(translations.field_required)"
                    v-model="item.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    clearable
                    dense
                    background-color="white"
                    :rules="validation(translations.field_required)"
                    :label="translations.label_select_crop"
                    :items="crop_items"
                    v-model="item.cropName"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    clearable
                    dense
                    background-color="white"
                    :rules="validation(translations.field_required)"
                    :label="translations.sampling_date"
                    type="date"
                    v-model="item.dateEND"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    clearable
                    dense
                    :label="translations.label_phonological_stage"
                    background-color="white"
                    v-model="item.phenologicalStage"
                    :items="phenologicalStages"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" v-if="packagesSolena.length != 0">
                  <v-autocomplete
                    outlined
                    clearable
                    dense
                    :rules="validation(translations.field_required)"
                    :label="translations.label_select_package"
                    background-color="white"
                    v-model="item.packageSolena"
                    :items="packagesSolena"
                    :item-text="formatItemText"
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    :label="translations.label_latitude"
                    clearable
                    type="number"
                    v-model="item.lat"
                    @input="validateCoordinates(index)"
                    :rules="latRules"
                    background-color="white"
                    class="mr-1"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    :label="translations.label_longitude"
                    clearable
                    type="number"
                    v-model="item.lng"
                    @input="validateCoordinates(index)"
                    :rules="lngRules"
                    background-color="white"
                    class="ml-1"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    :label="translations.label_search_qr"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    clearable
                    outlined
                    :items="item.qrList"
                    :no-data-text="translations.label_qr_not_found"
                    background-color="white"
                    :search-input.sync="item.searchCode"
                    v-model="item.code"
                    item-text="code"
                    @keydown="searchCodesdd(index)"
                    :rules="validation(translations.field_required)"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-container>

    <v-container v-else>
      <v-row justify="center">
        <v-col cols="12" xl="8" lg="8" md="8">
          <v-btn
            color="primary"
            elevation="15"
            fab
            small
            @click="isQRActive = false"
            class="mb-3 back-button"
          >
            <v-icon> mdi-arrow-left </v-icon>
          </v-btn>
          <v-card
            :height="
              this.$vuetify.breakpoint.name != 'xl' &&
              this.$vuetify.breakpoint.name != 'lg' &&
              this.$vuetify.breakpoint.name != 'md'
                ? '700'
                : '600'
            "
          >
            <v-card-text class="text-center" v-if="errorCamera.length > 0">
              <span class="red--text text-caption"> {{ errorCamera }}</span>
            </v-card-text>

            <qrcode-stream @init="onInit" class="mb" @decode="onDecode">
            </qrcode-stream>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- copyright -->
    <v-footer class="text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
  </v-container>
</template>

<script>
//validations
import {
  requiredValidation,
  requiredFValidation,
} from "@/helpers/validations.js";
// Vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
//components
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  components: {
    QrcodeStream,
  },
  data: () => ({
    isQRActive: false,
    sampleTypeSelected: null,
    errorCamera: "",
    isEmptyList: {
      error: false,
      message: "",
    },
    items: [],
    analysisType: [],
    vegetalSampleTypes: [],
    composition: [],
    crop_items: [],
    compostForm: {
      name: "",
      type: "",
      crop: "",
      composition: "",
      description: "",
      isCrop: true,
    },
    productForm: {
      name: "",
      type: "",
      brand: "",
      composition: "",
      crop: "",
      isCrop: true,
      activeIngredient: "",
      useFor: "",
    },
    substratumForm: {
      name: "",
      type: "",
      brand: "",
      crop: "",
      isCrop: true,
      description: "",
    },
    vegetalForm: {
      name: "",
      type: "",
      vegetalType: "",
      crop: "",
      description: "",
    },
    samplesNotAdvisorForm: {
      samples: [],
    },
    phenologicalStages: [],
    codes: [],
    coordinateError: false,
    organizationId: null,
    distributor: localStorage.getItem("distributionOrganizationId"),
    packagesSolena: [],
  }),
  computed: {
    ...mapState("session", ["language", "permissions"]),
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["crops"]),
    latRules() {
      return [
        () => !this.coordinateError || this.translations.bothFieldsRequired,
        (value) =>
          !value ||
          (value >= -90 && value <= 90) ||
          this.translations.latitudeRange,
      ];
    },
    lngRules() {
      return [
        () => !this.coordinateError || this.translations.bothFieldsRequired,
        (value) =>
          !value ||
          (value >= -180 && value <= 180) ||
          this.translations.longitudeRange,
      ];
    },
  },
  created() {
    this.analysisType = [
      { name: this.translations.label_valuation, value: "INITIAL" },
      { name: this.translations.label_measurement, value: "MONITORING" },
    ];
    this.vegetalSampleTypes = [
      {
        name: this.translations.vegetalSampleTypes["Seedling"],
        value: "Seedling",
      },
      { name: this.translations.vegetalSampleTypes["Root"], value: "Root" },
      { name: this.translations.vegetalSampleTypes["Seed"], value: "Seed" },
      { name: this.translations.vegetalSampleTypes["Stem"], value: "Stem" },
      { name: this.translations.vegetalSampleTypes["Leaf"], value: "Leaf" },
      {
        name: this.translations.vegetalSampleTypes["Fruit"],
        value: "Fruit",
      },
      {
        name: this.translations.vegetalSampleTypes["Flower"],
        value: "Flower",
      },
    ];
    this.composition = [
      { name: this.translations.compotition_types["LIQUID"], value: "LIQUID" },
      { name: this.translations.compotition_types["SOLID"], value: "SOLID" },
    ];
    this.isEmptyList = {
      error: false,
      message: this.translations.label_at_least_one_sample,
    };
    this.phenologicalStages = [
      {
        text: this.translations.phenologicalStages["Transplanting"],
        value: "Transplanting",
      },
      {
        text: this.translations.phenologicalStages["Vegetative growth"],
        value: "Vegetative growth",
      },
      {
        text: this.translations.phenologicalStages["Bloom"],
        value: "Bloom",
      },
      {
        text: this.translations.phenologicalStages["Harvest"],
        value: "Harvest",
      },
      {
        text: this.translations.phenologicalStages["Pre-planting"],
        value: "Pre-planting",
      },
      {
        text: this.translations.phenologicalStages["Sowing"],
        value: "Sowing",
      },
      {
        text: this.translations.phenologicalStages["Sprout"],
        value: "Sprout",
      },
      {
        text: this.translations.phenologicalStages["Tuberization"],
        value: "Tuberization",
      },
      {
        text: this.translations.phenologicalStages["Tuber filling"],
        value: "Tuber filling",
      },
      {
        text: this.translations.phenologicalStages["Foliage development"],
        value: "Foliage development",
      },
      {
        text: this.translations.phenologicalStages["Foliar expansion"],
        value: "Foliar expansion",
      },
      {
        text: this.translations.phenologicalStages["First leaf"],
        value: "First leaf",
      },
      {
        text: this.translations.phenologicalStages["Third leaf"],
        value: "Third leaf",
      },
      {
        text: this.translations.phenologicalStages["Fifth leaf"],
        value: "Fifth leaf",
      },
      {
        text: this.translations.phenologicalStages["Start of bulbing"],
        value: "Start of bulbing",
      },
      {
        text: this.translations.phenologicalStages["Bulb growth"],
        value: "Bulb growth",
      },
      {
        text: this.translations.phenologicalStages["Fruit maturity"],
        value: "Fruit maturity",
      },
      {
        text: this.translations.phenologicalStages["Sprouting"],
        value: "Sprouting",
      },
    ];
  },
  async mounted() {
    try {
      let user = JSON.parse(localStorage.getItem("user"));
      if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
        this.organizationId = localStorage.getItem("organizationId");
      } else {
        this.organizationId = localStorage.getItem("clientId");
      }
      await this.getPackges();
      this.setItemsPermissions();
    } catch (e) {
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: this.translations.advice_error,
        timeout: 4000,
      });
    }
    this.setCropItems();
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
      this.organizationId = localStorage.getItem("organizationId");
      this.SET_APPBAR_OPTIONS({
        leftButton: "menu",
        rightButton: "save",
        funcRightButton: this.save,
      });
    } else {
      this.organizationId = localStorage.getItem("clientId");
      this.SET_APPBAR_OPTIONS({
        leftButton: "menu_seller",
        funcLeftButton: this.goBack,
        rightButton: "save",
        funcRightButton: this.save,
      });
    }
  },
  methods: {
    ...mapActions("container", ["getContainers"]),
    ...mapActions("samples", [
      "saveNotGeoSample",
      "saveSampleNotAdvisor",
      "checkPermissionSampleNotAdvisor",
    ]),
    ...mapActions("packageSolena", [
      "getPackagesByDistributor",
      "getPackagesByClient",
    ]),
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    sampleTypeChange() {},
    goBack() {
      this.$router.push(`/seller-list/client/`);
    },
    validation(name) {
      return requiredValidation(name);
    },
    validationF(name) {
      return requiredFValidation(name);
    },
    formatItemText(item) {
      if (item.laboratoryName) {
        return `${item.name} - ${item.laboratoryName}`;
      } else {
        return `${item.name}`;
      }
    },
    async onInit(promise) {
      try {
        const { capabilities } = await promise;

        // successfully initialized
      } catch (error) {
        if (error.name === "NotAllowedError") {
          // user denied camera access permisson
          this.errorCamera =
            this.translations.label_user_denied_camera_access_permission;
        } else if (error.name === "NotFoundError") {
          // no suitable camera device installed
          this.errorCamera =
            this.translations.label_no_suitable_camera_device_installed;
        } else if (error.name === "NotSupportedError") {
          // page is not served over HTTPS (or localhost)
          this.errorCamera =
            this.translations.label_page_not_served_over_https_or_localhost;
        } else if (error.name === "NotReadableError") {
          // maybe camera is already in use
          this.errorCamera = this.translations.label_camera_may_be_in_use;
        } else if (error.name === "OverconstrainedError") {
          // did you requested the front camera although there is none?
          this.errorCamera =
            this.translations.label_requested_front_camera_although_none_available;
        } else if (error.name === "StreamApiNotSupportedError") {
          // browser seems to be lacking features
          this.errorCamera = this.translations.label_browser_lacks_features;
        }
      } finally {
        // hide loading indicator
      }
    },
    async save() {
      try {
        if (!this.isQRActive) {
          if (this.$refs.sampletForm.validate()) {
            switch (this.sampleTypeSelected) {
              case "COMPOST":
                if (this.$refs.compostForm.validate()) {
                  //all right save sample
                  this.isQRActive = true;
                }
                break;
              case "PRODUCT":
                if (this.$refs.productForm.validate()) {
                  //all right save sample
                  this.isQRActive = true;
                }
                break;
              case "SUBSTRATUM":
                if (this.$refs.substratumForm.validate()) {
                  //all right save sample
                  this.isQRActive = true;
                }
                break;
              case "VEGETABLE":
                if (this.$refs.vegetalForm.validate()) {
                  //all right save sample
                  this.isQRActive = true;
                }
                break;
              case "SOLENA_NO_ADVISOR":
                if (this.samplesNotAdvisorForm.samples.length <= 0) {
                  this.isEmptyList.error = true;
                }
                if (
                  this.$refs.samplesNotAdvisorForm.validate() &&
                  !this.isEmptyList.error
                ) {
                  this.SET_LOADER(true);
                  let client = null;
                  let user = JSON.parse(localStorage.getItem("user"));
                  if (
                    user.role == "ORG_USER" ||
                    user.role == "ORG_USER_ADMIN"
                  ) {
                    client = localStorage.getItem("organizationId");
                  } else {
                    client = localStorage.getItem("clientId");
                  }
                  let request = {
                    client: client,
                    samples: this.samplesNotAdvisorForm.samples.map(
                      ({ qrList, searchCode, packageSolena, ...rest }) => ({
                        ...rest,
                        packageSolena: packageSolena ? packageSolena._id : undefined,
                      })
                    ),
                  };

                  let response = await this.saveSampleNotAdvisor(request);
                  if (response && !response.error) {
                    //clean formularies
                    this.cleanForms();
                    this.sampleTypeSelected = null;
                    //sample created successfully
                    this.SET_ALERT_TYPE({
                      visible: true,
                      type: "success",
                      text: this.translations
                        .label_sample_successfully_registered,
                      timeout: 4000,
                    });
                  } else {
                    // show error
                    this.SET_ALERT_TYPE({
                      visible: true,
                      type: "error",
                      text: this.translations.advice_error,
                      timeout: 5000,
                    });
                  }
                }
                break;
            }
          }
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 5000,
        });
      }
      this.SET_LOADER(false);
    },
    setCropItems() {
      let cropsArray = Object.entries(this.translations.crop_name_list);
      for (let crop of cropsArray) {
        this.crop_items.push({
          text: crop[1],
          value: crop[0],
        });
      }
    },

    deleteItem(index) {
      this.samplesNotAdvisorForm.samples.splice(index, 1);
    },
    addItem() {
      this.samplesNotAdvisorForm.samples.push({
        name: "",
        cropName: "",
        dateEND: null,
        code: "",
        phenologicalStage: "",
        lat: null,
        lng: null,
        qrList: [],
        searchCode: null,
        packageSolena: undefined,
      });
    },
    cleanList() {
      this.samplesNotAdvisorForm.samples = [];
    },
    cleanForms() {
      this.errorCamera = "";
      this.isEmptyList = {
        error: false,
        message: this.translations.label_at_least_one_sample,
      };
      this.compostForm = {
        name: "",
        type: "",
        description: "",
      };
      this.productForm = {
        name: "",
        type: "",
        brand: "",
        activeIngredient: "",
        useFor: "",
      };
      this.substratumForm = {
        name: "",
        type: "",
        brand: "",
        description: "",
      };
      this.vegetalForm = {
        name: "",
        type: "",
        vegetalType: "",
        crop: "",
        description: "",
      };
      this.samplesNotAdvisorForm = {
        samples: [],
      };
      this.$refs.sampletForm.reset();
    },
    async onDecode(data) {
      try {
        this.SET_LOADER(true);
        let client = null;
        let user = JSON.parse(localStorage.getItem("user"));
        if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
          client = localStorage.getItem("organizationId");
        } else {
          client = localStorage.getItem("clientId");
        }
        let request = null;
        this.isQRActive = false;
        switch (this.sampleTypeSelected) {
          case "COMPOST":
            //all right save sample
            request = {
              sampleType: this.sampleTypeSelected,
              notes: this.compostForm.description,
              cropName: this.compostForm.isCrop ? this.compostForm.crop : "",
              tracingStatus: this.compostForm.type,
              client: client,
              samplePhotos: [{ folio: data }],
              fieldName: this.compostForm.name,
              composition: this.compostForm.composition,
            };
            break;
          case "PRODUCT":
            //all right save sample
            request = {
              sampleType: this.sampleTypeSelected,
              brandName: this.productForm.brand,
              notes: "",
              cropName: this.productForm.isCrop ? this.productForm.crop : "",
              tracingStatus: this.productForm.type,
              activeIngredient: this.productForm.activeIngredient,
              usedFor: this.productForm.useFor,
              client: client,
              samplePhotos: [{ folio: data }],
              fieldName: this.productForm.name,
              composition: this.productForm.composition,
            };
            break;
          case "SUBSTRATUM":
            //all right save sample
            request = {
              sampleType: this.sampleTypeSelected,
              brandName: this.substratumForm.brand,
              cropName: this.substratumForm.isCrop
                ? this.substratumForm.crop
                : "",
              notes: this.substratumForm.description,
              tracingStatus: this.substratumForm.type,
              client: client,
              samplePhotos: [{ folio: data }],
              fieldName: this.substratumForm.name,
            };
            break;
          case "VEGETABLE":
            //all right save sample
            request = {
              sampleType: this.sampleTypeSelected,
              cropName: this.vegetalForm.crop,
              vegetableType: this.vegetalForm.vegetalType,
              notes: this.vegetalForm.description,
              tracingStatus: this.vegetalForm.type,
              client: client,
              samplePhotos: [{ folio: data }],
              fieldName: this.vegetalForm.name,
            };
            break;
        }
        if (request) {
          let response = await this.saveNotGeoSample(request);
          if (response) {
            if (!response.error) {
              //clean formularies
              this.cleanForms();
              this.sampleTypeSelected = null;
              //sample created successfully
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: this.translations.label_sample_successfully_registered,
                timeout: 4000,
              });
            } else {
              if (response.code === 0) {
                // show error
                //qr code not exist
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: this.translations.label_enter_a_valid_folio,
                  timeout: 6000,
                });
              } else if (response.code === 1) {
                // show error
                //qr has been already registered
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: this.translations.label_enter_an_unregistered_folio,
                  timeout: 6000,
                });
              } else {
                // show error
                //other error
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: this.translations.advice_error,
                  timeout: 5000,
                });
              }
            }
          } else {
            // show error
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 5000,
            });
          }
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 5000,
        });
      }
      this.SET_LOADER(false);
    },
    setItemsPermissions() {
      this.items = [
        {
          name: this.translations.sampleTypeNotGeoAll["COMPOST"],
          value: "COMPOST",
        },
        {
          name: this.translations.sampleTypeNotGeoAll["PRODUCT"],
          value: "PRODUCT",
        },
        {
          name: this.translations.sampleTypeNotGeoAll["SUBSTRATUM"],
          value: "SUBSTRATUM",
        },
        {
          name: this.translations.sampleTypeNotGeoAll["VEGETABLE"],
          value: "VEGETABLE",
        },
      ];
      if (
        this.permissions.find(
          (permission) => permission == "sampler_not_georeferenced_soil"
        )
      ) {
        this.items.push({
          name: this.translations.soil,
          value: "SOLENA_NO_ADVISOR",
        });
      }
    },
    async searchCodesdd(index) {
      if (!this.samplesNotAdvisorForm.samples[index].searchCode) return;
      try {
        let payload = {
          code: this.samplesNotAdvisorForm.samples[index].searchCode,
        };
        let response = await this.getContainers(payload);

        this.$nextTick(() => {
          this.samplesNotAdvisorForm.samples[index].qrList =
            response.containers;
        });
      } catch (error) {
        console.log(error);
      }
    },
    validateCoordinates(index) {
      this.coordinateError =
        (this.samplesNotAdvisorForm.samples[index].lat !== null &&
          this.samplesNotAdvisorForm.samples[index].lat !== "" &&
          (this.samplesNotAdvisorForm.samples[index].lng === null ||
            this.samplesNotAdvisorForm.samples[index].lng === "")) ||
        (this.samplesNotAdvisorForm.samples[index].lng !== null &&
          this.samplesNotAdvisorForm.samples[index].lng !== "" &&
          (this.samplesNotAdvisorForm.samples[index].lat === null ||
            this.samplesNotAdvisorForm.samples[index].lat === ""));

      this.$nextTick(() => {
        this.$refs.samplesNotAdvisorForm &&
          this.$refs.samplesNotAdvisorForm.validate();
      });
    },
    async getPackges() {
      try {
        let response = null;
        let user = JSON.parse(localStorage.getItem("user"));
        if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
          response = await this.getPackagesByClient({
            commercialOrganizationId: this.organizationId,
          });
        } else {
          response = await this.getPackagesByDistributor({
            distributorId: this.distributor,
          });
        }
        this.packagesSolena = response;

        if (
          this.permissions.find(
            (permission) => permission == "not_package_in_sampling"
          ) &&
          this.packagesSolena.length != 0
        ) {
          this.packagesSolena.unshift({
            name: this.translations.label_not_applicable,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    samplesNotAdvisorForm: {
      handler(newValue) {
        if (this.samplesNotAdvisorForm.samples.length > 0) {
          this.isEmptyList.error = false;
        }
      },
      deep: true,
    },
    sampleTypeSelected() {
      if (!this.sampleTypeSelected) {
        this.cleanForms();
      }
    },
  },
};
</script>

<style scoped>
.box-white {
  background: #ffffff;
}
</style>
